"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDynamicCallback = function (callback) {
    var ref = react_1.useRef(callback);
    react_1.useLayoutEffect(function () {
        ref.current = callback;
    }, [callback]);
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ref.current.apply(ref, args);
    }, []);
};
exports.default = useDynamicCallback;
//# sourceMappingURL=useDynamicCallback.js.map